// extracted by mini-css-extract-plugin
module.exports = {"editProfileContainer":"EditProfile_editProfileContainer__1pv04","editHeader":"EditProfile_editHeader__2FGoj","tab":"EditProfile_tab__3Qt_j"};